/**
 * Privacy / Terms link-out under Clerk sign-in and sign-up.
 * Destinations come from getAppLinks() (canonical www marketing URLs).
 */
import { getAppLinks } from '@/config/links';

export function AuthLegalLinks() {
  const links = getAppLinks();
  return (
    <p className="mt-6 text-center text-xs text-muted-foreground" data-testid="auth-legal-links">
      <a
        href={links.privacy}
        target="_blank"
        rel="noopener noreferrer"
        className="underline underline-offset-2 hover:text-foreground"
      >
        Privacy
      </a>
      <span aria-hidden="true"> · </span>
      <a
        href={links.terms}
        target="_blank"
        rel="noopener noreferrer"
        className="underline underline-offset-2 hover:text-foreground"
      >
        Terms
      </a>
    </p>
  );
}
